<template>
  <div class="wlx-site-manager-wrapper wlx-user-manager certificate-type-manager">
    <header class="site-manager-head-con" style="padding-top: 20px">
      <el-form :inline="true" size="small">
        <el-form-item>
          <el-input
            v-model="typeName"
            placeholder="请输入证书类型"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="getCertificateTypeList()"
            >搜索</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-circle-plus-outline"
            @click="addInfo"
            >新增</el-button
          >
        </el-form-item>
      </el-form>
    </header>

    <div style="padding-left: 30px">
      <el-table :data="list">
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column prop="typeName" label="证书类型"></el-table-column>
        <el-table-column prop="type" label="类型">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 0">学生证书</span>
            <span v-if="scope.row.type == 1">师资证书</span>
          </template>
        </el-table-column>

        <el-table-column prop="certificateTemplate" label="证书模板">
          <template slot-scope="scope">
            <img
              v-if="scope.row.certificateTemplate"
              style="height: 60px"
              :src="scope.row.certificateTemplate"
              @click="clickImg(scope.row.certificateTemplate)"
            />
            <span v-else>未上传</span>
          </template>
        </el-table-column>
        <el-table-column prop="certificateDrawConfig" label="绘制配置">
          <template slot-scope="scope">
            <span v-if="scope.row.certificateDrawConfig">已配置</span>
            <span v-else>未配置</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="450">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="setGrade(scope.row)"
              >设置证书等级</el-button
            >
            <el-button size="mini" type="primary" @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-button size="mini" type="success" @click="openDesigner(scope.row)"
              >设计模板</el-button
            >
            <el-button
              size="mini"
              :type="scope.row.isQuery == 1 ? 'warning' : 'info'"
              @click="changeQueryStatus(scope.row)"
              >{{ scope.row.isQuery == 1 ? "开启查询" : "关闭查询" }}</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="deleteInfo(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="u-page-con">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="onPageChangeHandler"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
          v-show="totalCount > 0"
          style="text-align: center"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      title="编辑"
      :append-to-body="true"
      :visible.sync="dialogFormVisible"
      width="600px"
    >
      <el-form
        :inline="true"
        :model="form"
        class="demo-form-inline"
        label-width="200px"
      >
        <el-form-item label="证书类型">
          <el-input style="width: 300px" v-model="form.typeName"></el-input>
        </el-form-item>
        <el-form-item label="是否在查询成绩页面展示">
          <el-radio-group v-model="form.isShowScore">
            <el-radio :label="1">展示</el-radio>
            <el-radio :label="0">不展示</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否在查询证书页面展示">
          <el-radio-group v-model="form.isShowCertificate">
            <el-radio :label="1">展示</el-radio>
            <el-radio :label="0">不展示</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="关闭查询">
          <el-radio-group v-model="form.isQuery">
            <el-radio :label="1">关闭</el-radio>
            <el-radio :label="0">开启</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="成绩查询是否需要等级条件">
          <el-radio-group v-model="form.isScoreGrade">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="证书查询是否需要等级条件">
          <el-radio-group v-model="form.isCertificateGrade">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="查询证书">
            <el-input v-model="form.linkUrl" placeholder="请输入查询证书"></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-radio-group v-model="form.type">
            <el-radio :label="0">学生证书</el-radio>
            <el-radio :label="1">师资证书</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="证书模板">
          <imageUpload
            class="img_upload"
            :url="urlAliyunOSS"
            :files.sync="form.certificateTemplate"
            v-if="dialogFormVisible"
            format="image"
          ></imageUpload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelInfo">取 消</el-button>
        <el-button type="primary" @click="editInfo()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="证书模板设计"
      :append-to-body="true"
      :visible.sync="designerVisible"
      width="1280px"
      top="24px"
      class="certificate-designer-dialog"
      @closed="closeDesigner"
    >
      <div class="designer-toolbar">
        <div class="designer-title">
          <strong>{{ designerRow.typeName || "" }}</strong>
          <span v-if="designer.layout.imageWidth && designer.layout.imageHeight">
            原图：{{ designer.layout.imageWidth }} x {{ designer.layout.imageHeight }}
          </span>
        </div>
        <div class="designer-actions">
          <el-select
            v-model="designer.reuseTypeId"
            size="small"
            class="reuse-select"
            filterable
            clearable
            placeholder="复用其他模板"
          >
            <el-option
              v-for="item in designer.templateOptions"
              :key="item.id"
              :label="item.typeName"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-button size="small" @click="reuseDesignerLayout">复用坐标</el-button>
          <el-select v-model="designer.fieldToAdd" size="small" class="field-select" filterable placeholder="选择字段">
            <el-option
              v-for="item in fieldOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-button size="small" icon="el-icon-plus" @click="addDesignerField">添加字段</el-button>
          <el-button size="small" type="primary" :loading="designer.saving" @click="saveDesignerLayout">
            保存坐标
          </el-button>
          <el-button size="small" type="success" :loading="designer.previewing" @click="previewDesignerLayout">
            预览效果
          </el-button>
        </div>
      </div>

      <div class="designer-body">
        <div class="designer-canvas-panel">
          <div v-if="designerRow.certificateTemplate" ref="designerStage" class="designer-stage">
            <img
              ref="designerImage"
              class="designer-template-img"
              :src="designerRow.certificateTemplate"
              @load="onDesignerImageLoad"
            />
            <div
              v-for="field in designer.layout.fields"
              :key="field.id"
              class="designer-field"
              :class="{ active: field.id === designer.activeFieldId, disabled: !field.enabled, image: field.type === 'image' }"
              :style="getDesignerFieldStyle(field)"
              @mousedown.stop.prevent="startDragField($event, field)"
              @click.stop="selectDesignerField(field)"
            >
              {{ getDesignerFieldText(field) }}
            </div>
          </div>
        </div>

        <div class="designer-side-panel">
          <div v-if="!activeField" class="designer-empty">请选择或添加字段</div>
          <template v-else>
            <div class="active-field-head">
              <strong>{{ activeField.label }}</strong>
              <el-button type="text" class="danger-text" @click="removeActiveField">删除</el-button>
            </div>

            <el-form label-width="82px" size="mini" class="designer-form">
              <el-form-item label="类型">
                <el-radio-group v-model="activeField.type">
                  <el-radio-button label="text">文字</el-radio-button>
                  <el-radio-button label="image">图片</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="字段">
                <el-select v-model="activeField.field" filterable clearable @change="onActiveFieldChange">
                  <el-option
                    v-for="item in fieldOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="activeField.field === 'customText'" label="文字">
                <el-input v-model="activeField.text"></el-input>
              </el-form-item>
              <el-form-item label="X">
                <el-input-number v-model="activeField.x" :min="0" :step="1"></el-input-number>
              </el-form-item>
              <el-form-item label="Y">
                <el-input-number v-model="activeField.y" :min="0" :step="1"></el-input-number>
              </el-form-item>
              <el-form-item v-if="activeField.type === 'text'" label="Y补偿">
                <el-input-number v-model="activeField.yOffset" :min="-50" :max="50" :step="1"></el-input-number>
              </el-form-item>
              <el-form-item label="宽度">
                <el-input-number v-model="activeField.width" :min="0" :step="10"></el-input-number>
              </el-form-item>
              <el-form-item label="高度">
                <el-input-number v-model="activeField.height" :min="0" :step="10"></el-input-number>
              </el-form-item>
              <template v-if="activeField.type === 'text'">
                <el-form-item label="字号">
                  <el-input-number v-model="activeField.fontSize" :min="8" :max="180" :step="1"></el-input-number>
                </el-form-item>
                <el-form-item label="字体">
                  <el-select v-model="activeField.fontFamily" filterable allow-create>
                    <el-option
                      v-for="item in fontFamilyOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="颜色">
                  <el-color-picker v-model="activeField.color"></el-color-picker>
                </el-form-item>
                <el-form-item label="对齐">
                  <el-radio-group v-model="activeField.align">
                    <el-radio-button label="left">左</el-radio-button>
                    <el-radio-button label="center">中</el-radio-button>
                    <el-radio-button label="right">右</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="加粗">
                  <el-switch v-model="activeField.bold"></el-switch>
                </el-form-item>
              </template>
              <el-form-item label="启用">
                <el-switch v-model="activeField.enabled"></el-switch>
              </el-form-item>
              <el-form-item label="微调">
                <div class="nudge-buttons">
                  <el-button icon="el-icon-arrow-up" @click="nudgeActiveField(0, -1)"></el-button>
                  <el-button icon="el-icon-arrow-down" @click="nudgeActiveField(0, 1)"></el-button>
                  <el-button icon="el-icon-arrow-left" @click="nudgeActiveField(-1, 0)"></el-button>
                  <el-button icon="el-icon-arrow-right" @click="nudgeActiveField(1, 0)"></el-button>
                </div>
              </el-form-item>
            </el-form>
          </template>

          <div v-if="designer.previewUrl" class="server-preview">
            <div class="server-preview-title">证书效果预览</div>
            <img :src="designer.previewUrl" title="点击放大预览" @click="openServerPreviewLarge" />
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="designerVisible = false">关闭</el-button>
        <el-button type="primary" :loading="designer.saving" @click="saveDesignerLayout">保存坐标</el-button>
        <el-button type="success" :loading="designer.previewing" @click="previewDesignerLayout">预览效果</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="证书效果预览"
      :append-to-body="true"
      :visible.sync="serverPreviewVisible"
      width="92%"
      top="20px"
      class="server-preview-dialog"
    >
      <div class="server-preview-zoom-toolbar">
        <el-button size="mini" icon="el-icon-minus" @click="changeServerPreviewZoom(-10)">缩小</el-button>
        <el-slider
          v-model="serverPreviewZoom"
          class="server-preview-zoom-slider"
          :min="30"
          :max="200"
          :step="5"
          :show-tooltip="false"
        ></el-slider>
        <span class="server-preview-zoom-text">{{ serverPreviewZoom }}%</span>
        <el-button size="mini" icon="el-icon-plus" @click="changeServerPreviewZoom(10)">放大</el-button>
        <el-button size="mini" @click="resetServerPreviewZoom">重置</el-button>
      </div>
      <div class="server-preview-large">
        <img :src="designer.previewUrl" :style="serverPreviewLargeStyle" />
      </div>
    </el-dialog>

    <el-dialog
      title="设置证书等级"
      :modal="false"
      :visible.sync="dialogGradeVisible"
      width="800px"
    >
      <el-button
        type="primary"
        icon="el-icon-circle-plus-outline"
        @click="addGrade"
        >新增</el-button
      >
      <el-table :data="gradeList">
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column prop="lable" label="证书类型"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="editGrade(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="deleteGrade(scope.row.value)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      title="编辑"
      :modal="false"
      :visible.sync="dialogGradeAddVisible"
      width="600px"
    >
      <el-form
        :inline="true"
        :model="form"
        class="demo-form-inline"
        label-width="200px"
      >
        <el-form-item label="证书等级">
          <el-input v-model="gradeAddForm.gradeName"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogGradeAddVisible = false">取 消</el-button>
        <el-button type="primary" @click="editgrade()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="证书模板展示"
      :modal="false"
      top="10px"
      :visible.sync="imageUrlShow"
      width="1000px"
    >
      <div>
        <img :src="imageUrl"  style="width:900px;height:650px" />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="imageUrlClose">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import imageUpload from "components/imageUpload.vue";

export default {
  components: {
    imageUpload,
  },
  data() {
    return {
      page: 1,
      pageSize: 10,
      totalCount: 0,
      typeName: "",
      isShowScore: "",
      isShowCertificate: "",
      form: {
        id: "",
        typeName: "",
        isShowScore: "",
        isShowCertificate: "",
        isQuery: "",
        isScoreGrade: "",
        isCertificateGrade: "",
        type: "",
        linkUrl:"",
        certificateTemplate: "",
        certificateDrawConfig: "",
      },
      dialogFormVisible: false,
      list: [],
      // 设置证书等级
      gradeList: [],
      typeId: "",
      dialogGradeVisible: false,
      dialogGradeAddVisible: false,
      gradeAddForm: {
        id: "",
        gradeName: "",
      },
      imageUrl: "",
      imageUrlShow: false,
      urlAliyunOSS: "/api/design/osssign/getsign",
      designerVisible: false,
      serverPreviewVisible: false,
      serverPreviewZoom: 100,
      designerRow: {},
      designer: {
        layout: {
          version: 1,
          imageWidth: 0,
          imageHeight: 0,
          fields: [],
        },
        activeFieldId: "",
        fieldToAdd: "studentName",
        reuseTypeId: "",
        templateOptions: [],
        scale: 1,
        dragging: null,
        saving: false,
        previewing: false,
        previewUrl: "",
      },
      drawDialogVisible: false,
      drawItems: [],
      activeDrawIndex: -1,
      templateNaturalWidth: 0,
      templateNaturalHeight: 0,
      templateDisplayWidth: 900,
      dragState: null,
      fieldOptions: [
        { value: "studentName", label: "学生姓名" },
        { value: "studentNamePinyin", label: "姓名拼音" },
        { value: "idCard", label: "身份证号" },
        { value: "studentUrl", label: "照片" },
        { value: "examTime", label: "考试时间" },
        { value: "examTimeYearFZ", label: "发证年" },
        { value: "examTimeMonthFZ", label: "发证月" },
        { value: "examTimeDayFZ", label: "发证日" },
        { value: "dateofIssue", label: "发证年月" },
        { value: "examinationGrade", label: "证书等级" },
        { value: "examinationGradeEnglish", label: "证书等级英文" },
        { value: "examName", label: "考试名称" },
        { value: "certificateNum", label: "证书编号" },
        { value: "siteName", label: "考点名称" },
        { value: "QualifiedState", label: "合格状态" },
        { value: "awardingUnit", label: "颁证单位" },
        { value: "schoolName", label: "所在单位" },
        { value: "peixunName", label: "参训名称" },
        { value: "peixunTime", label: "参训时间" },
        { value: "effectiveTime", label: "有效期" },
        { value: "certificateType", label: "证书类型" },
        { value: "zsfx", label: "证书方向" },
        { value: "classHour", label: "学时" },
        { value: "studyTime", label: "默认学时40" },
        { value: "studyTimeg", label: "默认学时40" },
        { value: "studyTimegx", label: "默认学时32" },
        { value: "customText", label: "自定义文字" }
      ],
      fontFamilyOptions: ["微软雅黑", "宋体", "黑体", "SimSun", "Microsoft YaHei"],
      sampleValues: {
        studentName: "张三",
        studentNamePinyin: "Zhang San",
        idCard: "110101199001010010",
        studentUrl: "照片",
        examTime: "2026年05月07日",
        examTimeYearFZ: "2026",
        examTimeMonthFZ: "05",
        examTimeDayFZ: "07",
        dateofIssue: "2026年05月",
        examinationGrade: "中级",
        examinationGradeEnglish: "Intermediate Level",
        examName: "示例考试名称",
        certificateNum: "CERT-2026-0001",
        siteName: "示例考点",
        QualifiedState: "合格",
        awardingUnit: "中国物流与采购联合会",
        schoolName: "示例单位",
        peixunName: "示例参训名称",
        peixunTime: "2026/05/01~2026/05/07",
        effectiveTime: "2",
        certificateType: "示例证书类型",
        zsfx: "示例方向",
        classHour: "40",
        studyTime: "40",
        studyTimeg: "40",
        studyTimegx: "32",
        customText: "自定义文字",
      },
    };
  },
  computed: {
    drawScale() {
      if (!this.templateNaturalWidth || !this.templateDisplayWidth) {
        return 1;
      }
      return this.templateDisplayWidth / this.templateNaturalWidth;
    },
    activeDrawItem() {
      if (this.activeDrawIndex < 0) {
        return null;
      }
      return this.drawItems[this.activeDrawIndex] || null;
    },
    activeField() {
      return this.designer.layout.fields.find((item) => item.id === this.designer.activeFieldId);
    },
    serverPreviewLargeStyle() {
      return {
        width: `${this.serverPreviewZoom}%`,
      };
    },
  },
  created() {
    this.getCertificateTypeList();
  },
  beforeDestroy() {
    this.removeDragEvents();
    this.removeDragListeners();
    window.removeEventListener("resize", this.syncDesignerScale);
  },
  methods: {
    openDesigner(row) {
      if (!row.certificateTemplate) {
        this.$message.warning("请先填写证书模板地址");
        return;
      }
      this.designerRow = Object.assign({}, row, {
        certificateTemplate: this.normalizeOssUrl(row.certificateTemplate),
      });
      this.designer.layout = this.parseDesignerLayout(row.certificateDrawConfig);
      this.designer.activeFieldId = this.designer.layout.fields.length ? this.designer.layout.fields[0].id : "";
      this.designer.reuseTypeId = "";
      this.designer.previewUrl = "";
      this.designer.templateOptions = this.list.filter((item) => item.id !== row.id && item.certificateDrawConfig);
      this.designerVisible = true;
      this.loadDesignerTemplateOptions(row.id);
      window.addEventListener("resize", this.syncDesignerScale);
      this.$nextTick(this.syncDesignerScale);
    },
    loadDesignerTemplateOptions(currentTypeId) {
      this.$http
        .post("/api/XOrg/CertificateTypeManager/getCertificateTypeList", {
          PageSize: 1000,
          page: 1,
        })
        .then((rst) => {
          if (rst.code > 0) {
            this.designer.templateOptions = (rst.list || []).filter((item) => {
              return item.id !== currentTypeId && item.certificateDrawConfig;
            });
          }
        });
    },
    closeDesigner() {
      this.removeDragListeners();
      window.removeEventListener("resize", this.syncDesignerScale);
      this.designerRow = {};
      this.serverPreviewVisible = false;
    },
    createEmptyLayout() {
      return {
        version: 1,
        imageWidth: 0,
        imageHeight: 0,
        fields: [],
      };
    },
    parseDesignerLayout(configText) {
      var layout = this.createEmptyLayout();
      if (!configText) {
        return layout;
      }
      try {
        var config = JSON.parse(configText);
        var fields = Array.isArray(config) ? config : config.items || config.fields || [];
        layout.fields = fields.map((field, index) => this.normalizeFieldFromConfig(field, index));
        layout.imageWidth = config.imageWidth || 0;
        layout.imageHeight = config.imageHeight || 0;
      } catch (e) {
        this.$message.warning("坐标配置格式异常，已按空配置打开");
      }
      return layout;
    },
    normalizeFieldFromConfig(field, index) {
      var option = this.fieldOptions.find((item) => item.value === field.field);
      var type = field.type === "image" ? "image" : "text";
      return {
        id: field.id || `${field.field || type}_${Date.now()}_${index}`,
        label: field.label || (option ? option.label : field.text || "字段"),
        type,
        field: field.field || (field.text ? "customText" : ""),
        text: field.text || "",
        url: field.url || "",
        x: Number(field.x) || 0,
        y: Number(field.y) || 0,
        width: Number(field.width) || (type === "image" ? 120 : 600),
        height: Number(field.height) || (type === "image" ? 160 : 0),
        fontSize: Number(field.fontSize) || 32,
        yOffset: field.yOffset === undefined || field.yOffset === null ? 0 : Number(field.yOffset),
        fontFamily: field.fontName || field.fontFamily || "微软雅黑",
        color: field.color || "#000000",
        align: field.align || "left",
        bold: field.bold === true,
        enabled: field.visible !== false && field.enabled !== false,
      };
    },
    onDesignerImageLoad(event) {
      var img = event.target;
      if (!this.designer.layout.imageWidth) {
        this.designer.layout.imageWidth = img.naturalWidth;
      }
      if (!this.designer.layout.imageHeight) {
        this.designer.layout.imageHeight = img.naturalHeight;
      }
      this.$nextTick(this.syncDesignerScale);
    },
    syncDesignerScale() {
      this.$nextTick(() => {
        var img = this.$refs.designerImage;
        if (!img || !img.naturalWidth) {
          return;
        }
        this.designer.scale = img.clientWidth / img.naturalWidth;
      });
    },
    addDesignerField() {
      var option = this.fieldOptions.find((item) => item.value === this.designer.fieldToAdd) || this.fieldOptions[0];
      var type = option.value === "studentUrl" ? "image" : "text";
      var field = this.normalizeFieldFromConfig({
        id: `${option.value}_${Date.now()}`,
        label: option.label,
        type,
        field: option.value,
        text: option.value === "customText" ? "自定义文字" : "",
        x: 120,
        y: 120 + this.designer.layout.fields.length * 48,
        width: type === "image" ? 160 : 700,
        height: type === "image" ? 220 : 0,
        fontSize: 32,
      }, this.designer.layout.fields.length);
      this.designer.layout.fields.push(field);
      this.designer.activeFieldId = field.id;
    },
    onActiveFieldChange(value) {
      if (!this.activeField) {
        return;
      }
      var option = this.fieldOptions.find((item) => item.value === value);
      this.activeField.label = option ? option.label : value;
      if (value === "studentUrl") {
        this.activeField.type = "image";
        this.activeField.width = this.activeField.width || 160;
        this.activeField.height = this.activeField.height || 220;
      }
    },
    selectDesignerField(field) {
      this.designer.activeFieldId = field.id;
    },
    getDesignerFieldStyle(field) {
      var scale = this.designer.scale || 1;
      var style = {
        left: `${field.x * scale}px`,
        top: `${field.y * scale}px`,
        width: field.width ? `${field.width * scale}px` : "auto",
        minHeight: field.height ? `${field.height * scale}px` : "22px",
        fontSize: `${Math.max((field.fontSize || 32) * scale, 12)}px`,
        fontFamily: field.fontFamily,
        color: field.color,
        fontWeight: field.bold ? "700" : "400",
        textAlign: field.align,
      };
      if (field.type === "image") {
        style.height = `${(field.height || 160) * scale}px`;
        style.lineHeight = `${(field.height || 160) * scale}px`;
      }
      return style;
    },
    getDesignerFieldText(field) {
      if (field.type === "image") {
        return field.label || "图片";
      }
      if (field.field === "customText") {
        return field.text || "自定义文字";
      }
      return this.sampleValues[field.field] || field.label || "字段";
    },
    startDragField(event, field) {
      this.selectDesignerField(field);
      var scale = this.designer.scale || 1;
      this.designer.dragging = {
        field,
        startX: event.clientX,
        startY: event.clientY,
        originX: field.x,
        originY: field.y,
        scale,
      };
      document.addEventListener("mousemove", this.onDragField);
      document.addEventListener("mouseup", this.stopDragField);
    },
    onDragField(event) {
      var drag = this.designer.dragging;
      if (!drag) {
        return;
      }
      var x = drag.originX + (event.clientX - drag.startX) / drag.scale;
      var y = drag.originY + (event.clientY - drag.startY) / drag.scale;
      drag.field.x = Math.max(0, Math.round(x));
      drag.field.y = Math.max(0, Math.round(y));
    },
    stopDragField() {
      this.removeDragListeners();
      this.designer.dragging = null;
    },
    removeDragListeners() {
      document.removeEventListener("mousemove", this.onDragField);
      document.removeEventListener("mouseup", this.stopDragField);
    },
    nudgeActiveField(dx, dy) {
      if (!this.activeField) {
        return;
      }
      this.activeField.x = Math.max(0, Math.round(this.activeField.x + dx));
      this.activeField.y = Math.max(0, Math.round(this.activeField.y + dy));
    },
    removeActiveField() {
      if (!this.activeField) {
        return;
      }
      var index = this.designer.layout.fields.findIndex((item) => item.id === this.activeField.id);
      if (index >= 0) {
        this.designer.layout.fields.splice(index, 1);
      }
      this.designer.activeFieldId = this.designer.layout.fields.length ? this.designer.layout.fields[0].id : "";
    },
    reuseDesignerLayout() {
      if (!this.designer.reuseTypeId) {
        this.$message.warning("请选择要复用的模板");
        return;
      }
      var row = this.list.find((item) => item.id === this.designer.reuseTypeId);
      if (!row || !row.certificateDrawConfig) {
        this.$message.warning("选择的模板还没有坐标配置");
        return;
      }
      this.designer.layout.fields = this.parseDesignerLayout(row.certificateDrawConfig).fields;
      this.designer.activeFieldId = this.designer.layout.fields.length ? this.designer.layout.fields[0].id : "";
      this.$message.success("已复用坐标，请确认后保存");
    },
    getDesignerPayload() {
      var fields = this.designer.layout.fields.map((field) => {
        var item = {
          type: field.type,
          x: Number(field.x || 0),
          y: Number(field.y || 0),
          visible: field.enabled !== false,
        };
        if (field.field && field.field !== "customText") {
          item.field = field.field;
        }
        if (field.field === "customText" || field.text) {
          item.text = field.text || "自定义文字";
        }
        if (field.type === "image") {
          item.width = Number(field.width || 0);
          item.height = Number(field.height || 0);
          if (field.url) {
            item.url = field.url;
          }
        } else {
          if (field.width) {
            item.width = Number(field.width);
          }
          if (field.height) {
            item.height = Number(field.height);
          }
          item.fontName = field.fontFamily || "微软雅黑";
          item.fontSize = Number(field.fontSize || 32);
          item.color = field.color || "#000000";
          item.align = field.align || "left";
          if (Number(field.yOffset) !== 0) {
            item.yOffset = Number(field.yOffset || 0);
          }
          if (field.bold) {
            item.bold = true;
          }
        }
        return item;
      });
      return JSON.stringify(fields);
    },
    saveDesignerLayout() {
      if (!this.designerRow.id) {
        return;
      }
      this.designer.saving = true;
      var config = this.getDesignerPayload();
      this.$http
        .post("/api/XOrg/CertificateTypeManager/addOrEditCertificateType", {
          id: this.designerRow.id,
          typeName: this.designerRow.typeName,
          isShowScore: this.designerRow.isShowScore,
          isShowCertificate: this.designerRow.isShowCertificate,
          isQuery: this.designerRow.isQuery,
          isScoreGrade: this.designerRow.isScoreGrade,
          isCertificateGrade: this.designerRow.isCertificateGrade,
          type: this.designerRow.type,
          linkUrl: this.designerRow.linkUrl,
          certificateTemplate: this.normalizeOssUrl(this.designerRow.certificateTemplate),
          certificateDrawConfig: config,
        })
        .then((rst) => {
          if (rst.code > 0) {
            this.$message.success(rst.msg || "保存成功");
            this.designerRow.certificateDrawConfig = config;
            this.designer.previewUrl = "";
            var row = this.list.find((item) => item.id === this.designerRow.id);
            if (row) {
              row.certificateDrawConfig = config;
            }
          } else {
            this.$message.warning(rst.msg);
          }
        })
        .finally(() => {
          this.designer.saving = false;
        });
    },
    previewDesignerLayout() {
      if (!this.designerRow.certificateTemplate) {
        this.$message.warning("请先上传证书模板");
        return;
      }
      var config = this.getDesignerPayload();
      if (!config || config === "[]") {
        this.$message.warning("请先添加字段");
        return;
      }
      this.designer.previewing = true;
      this.$http
        .post("/api/XOrg/CertificateTypeManager/previewCertificateDrawConfig", {
          certificateTemplate: this.normalizeOssUrl(this.designerRow.certificateTemplate),
          certificateDrawConfig: config,
        })
        .then((rst) => {
          if (rst.code > 0) {
            this.designer.previewUrl = rst.previewUrl;
          } else {
            this.$message.warning(rst.msg);
          }
        })
        .finally(() => {
          this.designer.previewing = false;
        });
    },
    openServerPreviewLarge() {
      if (this.designer.previewUrl) {
        this.serverPreviewZoom = 100;
        this.serverPreviewVisible = true;
      }
    },
    changeServerPreviewZoom(delta) {
      var nextZoom = this.serverPreviewZoom + delta;
      this.serverPreviewZoom = Math.min(200, Math.max(30, nextZoom));
    },
    resetServerPreviewZoom() {
      this.serverPreviewZoom = 100;
    },
    openDrawDialog() {
      this.parseDrawConfig();
      this.drawDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.templateImage && this.$refs.templateImage.complete) {
          this.onTemplateLoad({ target: this.$refs.templateImage });
        }
      });
    },
    parseDrawConfig() {
      var config = [];
      if (this.form.certificateDrawConfig) {
        try {
          var json = JSON.parse(this.form.certificateDrawConfig);
          config = Array.isArray(json) ? json : json.items || [];
        } catch (e) {
          this.$message.warning("证书绘制配置JSON格式错误，已重置为空配置");
          config = [];
        }
      }
      this.drawItems = config.map((item, index) => this.normalizeDrawItem(item, index));
      this.activeDrawIndex = this.drawItems.length > 0 ? 0 : -1;
      this.syncDrawConfig();
    },
    normalizeDrawItem(item, index) {
      return {
        id: item.id || "draw_" + new Date().getTime() + "_" + index,
        type: item.type || "text",
        field: item.field || "",
        text: item.text || "",
        url: item.url || "",
        x: Number(item.x || 0),
        y: Number(item.y || 0),
        width: Number(item.width || 0),
        height: Number(item.height || 0),
        fontName: item.fontName || "微软雅黑",
        fontSize: Number(item.fontSize || 13),
        yOffset: item.yOffset === undefined || item.yOffset === null ? 0 : Number(item.yOffset),
        color: item.color || "#000000",
        bold: item.bold || false,
        italic: item.italic || false,
        align: item.align || "left",
        verticalAlign: item.verticalAlign || "top",
        visible: item.visible !== false,
      };
    },
    syncDrawConfig() {
      var list = this.drawItems.map((item) => {
        var config = {
          type: item.type,
          field: item.field,
          x: Number(item.x || 0),
          y: Number(item.y || 0),
        };
        if (item.text) {
          config.text = item.text;
        }
        if (item.type === "image") {
          config.width = Number(item.width || 0);
          config.height = Number(item.height || 0);
          if (item.url) {
            config.url = item.url;
          }
        } else {
          if (item.width) {
            config.width = Number(item.width);
          }
          if (item.height) {
            config.height = Number(item.height);
          }
          config.fontName = item.fontName || "微软雅黑";
          config.fontSize = Number(item.fontSize || 13);
          config.color = item.color || "#000000";
          config.align = item.align || "left";
          if (Number(item.yOffset) !== 0) {
            config.yOffset = Number(item.yOffset || 0);
          }
          if (item.bold) {
            config.bold = true;
          }
          if (item.italic) {
            config.italic = true;
          }
          if (item.verticalAlign && item.verticalAlign !== "top") {
            config.verticalAlign = item.verticalAlign;
          }
        }
        return config;
      });
      this.form.certificateDrawConfig = list.length > 0 ? JSON.stringify(list) : "";
    },
    saveDrawDialog() {
      this.syncDrawConfig();
      this.drawDialogVisible = false;
    },
    addDrawItem(type) {
      var item = this.normalizeDrawItem({
        type: type,
        field: type === "image" ? "studentUrl" : "studentName",
        text: type === "image" ? "" : "文字",
        x: 100,
        y: 100,
        width: type === "image" ? 120 : 0,
        height: type === "image" ? 160 : 0,
        fontSize: 13,
      }, this.drawItems.length);
      this.drawItems.push(item);
      this.activeDrawIndex = this.drawItems.length - 1;
      this.syncDrawConfig();
    },
    deleteDrawItem() {
      if (this.activeDrawIndex < 0) {
        return;
      }
      this.drawItems.splice(this.activeDrawIndex, 1);
      this.activeDrawIndex = this.drawItems.length > 0 ? Math.min(this.activeDrawIndex, this.drawItems.length - 1) : -1;
      this.syncDrawConfig();
    },
    selectDrawItem(row) {
      this.activeDrawIndex = this.drawItems.indexOf(row);
    },
    onTemplateLoad(event) {
      var img = event.target;
      this.templateNaturalWidth = img.naturalWidth || img.width;
      this.templateNaturalHeight = img.naturalHeight || img.height;
      this.templateDisplayWidth = img.clientWidth || 900;
    },
    getDrawItemStyle(item) {
      var scale = this.drawScale;
      var style = {
        left: item.x * scale + "px",
        top: item.y * scale + "px",
        fontSize: Math.max(12, item.fontSize * scale) + "px",
        color: item.color || "#000000",
        fontWeight: item.bold ? "bold" : "normal",
        textAlign: item.align || "left",
      };
      if (item.width) {
        style.width = item.width * scale + "px";
      }
      if (item.height) {
        style.height = item.height * scale + "px";
        style.lineHeight = item.height * scale + "px";
      }
      if (item.type === "image") {
        style.width = (item.width || 120) * scale + "px";
        style.height = (item.height || 160) * scale + "px";
        style.lineHeight = (item.height || 160) * scale + "px";
      }
      return style;
    },
    getDrawPreviewText(item) {
      if (item.text && !item.field) {
        return item.text;
      }
      var option = this.fieldOptions.find((field) => field.value === item.field);
      return option ? option.label : item.text || item.field || "文字";
    },
    startDrag(event, index) {
      this.activeDrawIndex = index;
      var item = this.drawItems[index];
      this.dragState = {
        startX: event.clientX,
        startY: event.clientY,
        itemX: item.x,
        itemY: item.y,
      };
      document.addEventListener("mousemove", this.onDragging);
      document.addEventListener("mouseup", this.stopDrag);
    },
    onDragging(event) {
      if (!this.dragState || this.activeDrawIndex < 0) {
        return;
      }
      var item = this.drawItems[this.activeDrawIndex];
      var scale = this.drawScale || 1;
      item.x = Math.max(0, Math.round(this.dragState.itemX + (event.clientX - this.dragState.startX) / scale));
      item.y = Math.max(0, Math.round(this.dragState.itemY + (event.clientY - this.dragState.startY) / scale));
      this.syncDrawConfig();
    },
    stopDrag() {
      this.dragState = null;
      this.removeDragEvents();
      this.syncDrawConfig();
    },
    removeDragEvents() {
      document.removeEventListener("mousemove", this.onDragging);
      document.removeEventListener("mouseup", this.stopDrag);
    },
    deleteGrade(id) {
      var that = this;
      this.$confirm("此操作将删除该证书等级数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        that.$http
          .post("/api/XOrg/CertGradeMgr/deleteCertificateType", {
            ids: id,
          })
          .then(function (rst) {
            if (rst.code > 0) {
              that.$message.success(rst.msg);
              that.getCertificateType();
            } else {
              that.$message.warning(rst.msg);
            }
          });
      });
    },
    editGrade(row) {
      this.gradeAddForm.id = row.value;
      this.gradeAddForm.gradeName = row.lable;
      this.dialogGradeAddVisible = true;
    },
    clickImg(url) {
      this.imageUrl = url;
      this.imageUrlShow = true;
    },
    imageUrlClose(){
        this.imageUrlShow=false;
    },
    addGrade() {
      this.gradeAddForm.id = "";
      this.gradeAddForm.gradeName = "";
      this.dialogGradeAddVisible = true;
    },
    cancelAddGrade() {
      this.dialogGradeAddVisible = false;
      this.gradeAddForm.id = "";
      this.gradeAddForm.gradeName = "";
    },
    editgrade() {
      var that = this;
      this.$http
        .post("/api/XOrg/CertGradeMgr/addOrEditCertGrade", {
          id: this.gradeAddForm.id,
          typeId: this.typeId,
          gradeName: this.gradeAddForm.gradeName,
        })
        .then(function (rst) {
          if (rst.code > 0) {
            that.$message.success(rst.msg);
            that.getCertificateType();
            that.cancelAddGrade();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    // 设置证书等级
    setGrade(row) {
      this.typeId = row.id;
      this.getCertificateType();
      this.dialogGradeVisible = true;
    },
    // 获取证书等级
    getCertificateType() {
      var that = this;
      this.$http
        .post("/api/XOrg/CertGradeMgr/getCertificateGrade", {
          typeId: this.typeId,
        })
        .then(function (rst) {
          if (rst.code > 0) {
            that.gradeList = rst.list;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    cancelInfo() {
      this.form.id = "";
      this.form.typeName = "";
      this.form.isShowScore = "";
      this.form.isShowCertificate = "";
      this.form.isQuery = "";
      this.form.isScoreGrade = "";
      this.form.isCertificateGrade = "";
      this.form.certificateTemplate="";
      this.form.certificateDrawConfig = "";
      this.form.type = "";
      this.form.linkUrl = "";
      this.drawItems = [];
      this.activeDrawIndex = -1;
      this.dialogFormVisible = false;
    },
    addInfo() {
      this.cancelInfo();
      this.dialogFormVisible = true;
    },
    //编辑
    editInfo() {
      var that = this;
      this.form.certificateTemplate = this.normalizeOssUrl(this.form.certificateTemplate);
      this.$http
        .post("/api/XOrg/CertificateTypeManager/addOrEditCertificateType", {
          id: this.form.id,
          typeName: this.form.typeName,
          isShowScore: this.form.isShowScore,
          isShowCertificate: this.form.isShowCertificate,
          isQuery: this.form.isQuery,
          isScoreGrade: this.form.isScoreGrade,
          isCertificateGrade: this.form.isCertificateGrade,
          type: this.form.type,
          linkUrl: this.form.linkUrl,
          certificateTemplate: this.form.certificateTemplate,
          certificateDrawConfig: this.form.certificateDrawConfig,
        })
        .then(function (rst) {
          if (rst.code > 0) {
            that.$message.success(rst.msg);
            that.cancelInfo();
            that.getCertificateTypeList();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    //弹出框赋值
    handleEdit(row) {
      this.form.id = row.id;
      this.form.typeName = row.typeName;
      this.form.isShowScore = row.isShowScore;
      this.form.isShowCertificate = row.isShowCertificate;
      this.form.isQuery = row.isQuery;
      this.form.isScoreGrade = row.isScoreGrade;
      this.form.isCertificateGrade = row.isCertificateGrade;
      this.form.certificateTemplate = this.normalizeOssUrl(row.certificateTemplate);
      this.form.certificateDrawConfig = row.certificateDrawConfig || "";
      this.form.type = row.type;
      this.form.linkUrl = row.linkUrl;
      this.parseDrawConfig();
      this.dialogFormVisible = true;
    },
    normalizeOssUrl(url) {
      if (!url) {
        return "";
      }
      return url
        .replace("https://file.clpp.org.cn/", "https://zhykt.oss-cn-shanghai.aliyuncs.com/")
        .replace("http://file.clpp.org.cn/", "https://zhykt.oss-cn-shanghai.aliyuncs.com/");
    },
    //删除
    deleteInfo(id) {
      var that = this;
      this.$confirm("此操作将删除该证书类型数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        that.$http
          .post("/api/XOrg/CertificateTypeManager/deleteCertificateType", {
            ids: id,
          })
          .then(function (rst) {
            if (rst.code > 0) {
              that.$message.success(rst.msg);
              that.getCertificateTypeList();
            } else {
              that.$message.warning(rst.msg);
            }
          });
      });
    },
    changeQueryStatus(row) {
      var nextStatus = row.isQuery == 1 ? 0 : 1;
      var actionText = nextStatus == 1 ? "关闭查询" : "开启查询";
      this.$confirm(`确定要${actionText}【${row.typeName}】吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http
          .post("/api/XOrg/CertificateTypeManager/changeCertificateTypeQueryStatus", {
            id: row.id,
            isQuery: nextStatus,
          })
          .then((rst) => {
            if (rst.code > 0) {
              this.$message.success(rst.msg);
              row.isQuery = nextStatus;
            } else {
              this.$message.warning(rst.msg);
            }
          });
      });
    },
    //查询
    getCertificateTypeList() {
      var that = this;
      this.$http
        .post("/api/XOrg/CertificateTypeManager/getCertificateTypeList", {
          typeName: this.typeName,
          isShowScore: this.isShowScore,
          isShowCertificate: this.isShowCertificate,
          PageSize: that.pageSize,
          page: that.page,
        })
        .then(function (rst) {
          if (rst.code > 0) {
            that.list = rst.list.map((item) => {
              item.certificateTemplate = that.normalizeOssUrl(item.certificateTemplate);
              return item;
            });
            that.page = rst.pagination.pageIndex;
            that.pageSize = rst.pagination.pageSize;
            that.totalCount = rst.pagination.totalCount;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getCertificateTypeList();
    },
    onPageChangeHandler(val) {
      this.page = val;
      this.getCertificateTypeList();
    },
  },
};
</script>

<style lang="scss">
.wlx-site-manager-wrapper {
  .demo-form-inline {
    .el-input__inner {
      width: 200px;
    }

    .img_upload {
      width: 500px;
    }
  }

  .draw-config-state {
    margin-left: 10px;
    color: #606266;
  }

  .draw-editor {
    display: flex;
    gap: 16px;
  }

  .draw-editor-main {
    width: 860px;
  }

  .draw-toolbar {
    margin-bottom: 10px;
  }

  .draw-stage {
    position: relative;
    width: 860px;
    max-height: 620px;
    overflow: auto;
    border: 1px solid #dcdfe6;
    background: #f5f7fa;
  }

  .draw-template-img {
    display: block;
    width: 100%;
    height: auto;
  }

  .draw-item {
    position: absolute;
    min-width: 30px;
    min-height: 18px;
    padding: 1px 3px;
    border: 1px dashed #409eff;
    background: rgba(255, 255, 255, 0.55);
    cursor: move;
    white-space: nowrap;
    overflow: hidden;
    box-sizing: border-box;
  }

  .draw-item.image {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    background: rgba(64, 158, 255, 0.12);
  }

  .draw-item.active {
    border: 2px solid #f56c6c;
    background: rgba(245, 108, 108, 0.12);
  }

  .draw-editor-side {
    width: 260px;
  }

  .draw-item-form {
    margin-top: 12px;
  }

  .draw-item-form .el-select,
  .draw-item-form .el-input,
  .draw-item-form .el-input-number {
    width: 170px;
  }

  .draw-empty,
  .draw-empty-side {
    color: #909399;
    text-align: center;
    padding: 60px 0;
    border: 1px dashed #dcdfe6;
  }
}

.certificate-type-manager {
  .template-thumb {
    height: 60px;
    cursor: pointer;
  }
}

.certificate-designer-dialog {
  .el-dialog__body {
    padding-top: 10px;
  }

  .designer-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 12px;
  }

  .designer-title {
    display: flex;
    align-items: center;
    gap: 12px;
    color: #333;
  }

  .designer-title span {
    color: #909399;
    font-size: 12px;
  }

  .designer-actions {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .field-select {
    width: 160px;
  }

  .reuse-select {
    width: 190px;
  }

  .designer-body {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 330px;
    gap: 16px;
    min-height: 640px;
  }

  .designer-canvas-panel {
    overflow: auto;
    border: 1px solid #dcdfe6;
    background: #f5f7fa;
    padding: 16px;
  }

  .designer-stage {
    position: relative;
    display: inline-block;
    line-height: 0;
  }

  .designer-template-img {
    display: block;
    max-width: 860px;
    width: 100%;
    height: auto;
    user-select: none;
  }

  .designer-field {
    position: absolute;
    min-height: 22px;
    line-height: 1.2;
    padding: 2px 4px;
    border: 1px dashed #409eff;
    background: rgba(255, 255, 255, 0.35);
    cursor: move;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;
  }

  .designer-field.image {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    background: rgba(64, 158, 255, 0.12);
  }

  .designer-field.active {
    border: 2px solid #f56c6c;
    background: rgba(245, 108, 108, 0.12);
  }

  .designer-field.disabled {
    opacity: 0.45;
  }

  .designer-side-panel {
    border: 1px solid #dcdfe6;
    padding: 12px;
    overflow: auto;
  }

  .designer-empty {
    color: #909399;
    text-align: center;
    padding-top: 120px;
  }

  .active-field-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
  }

  .danger-text {
    color: #f56c6c;
  }

  .designer-form .el-select,
  .designer-form .el-input-number {
    width: 190px;
  }

  .nudge-buttons {
    display: grid;
    grid-template-columns: repeat(4, 38px);
    gap: 6px;
  }

  .nudge-buttons .el-button {
    margin: 0;
    padding: 7px;
  }

  .server-preview {
    margin-top: 16px;
    border-top: 1px solid #ebeef5;
    padding-top: 12px;
  }

  .server-preview-title {
    margin-bottom: 8px;
    font-weight: 700;
    color: #303133;
  }

  .server-preview img {
    width: 100%;
    border: 1px solid #ebeef5;
    cursor: zoom-in;
  }
}

.server-preview-dialog {
  .el-dialog__body {
    padding: 12px;
  }

  .server-preview-zoom-toolbar {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    margin-bottom: 10px;
  }

  .server-preview-zoom-slider {
    width: 220px;
  }

  .server-preview-zoom-text {
    width: 48px;
    text-align: right;
    color: #606266;
  }

  .server-preview-large {
    max-height: calc(100vh - 130px);
    overflow: auto;
    text-align: center;
    background: #f5f7fa;
    border: 1px solid #ebeef5;
  }

  .server-preview-large img {
    max-width: none;
    height: auto;
    display: inline-block;
  }
}
</style>
